/**
 * eReg Settings Page
 */

import { Settings as SettingsIcon } from 'lucide-react';

export function Settings() {
  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white rounded-xl border border-gray-200 p-8 text-center dark:bg-gray-800 dark:border-gray-700">
        <SettingsIcon size={48} className="mx-auto mb-4 text-gray-300 dark:text-gray-600" />
        <h2 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-1">Settings</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Notification preferences and user settings coming soon.
        </p>
      </div>
    </div>
  );
}
